import theme from "@/theme";

export const styles = {
  appBar: {
    height: "54px",
    padding: "15px 0 15px 16px",
    borderColor: "divider",
    bgcolor: "white",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },

  appBarContainer: {
    display: "flex",
    alignItems: "center",
  },

  // subpage
  inputLabel: {
    fontSize: "20px",
    color: theme.palette.custom.blueGray900,
    fontWeight: 500,
    left: "-13px !important",
    lineHeight: "24px",
    fontStyle: "normal",
  },
  inputPropsEmail: {
    sx: {
      height: "54px",
      marginTop: "0.625rem",
      borderRadius: "3.125rem",
      fontSize: "1rem",
      "& input": {
        height: "100%",
        padding: "0 16px",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
      },
    },
  },
  inputProps: {
    sx: {
      height: "54px",
      marginTop: "0.625rem",
      borderRadius: "3.125rem",
      fontSize: "1rem",
      padding: 0,
      "& input": {
        height: "100%",
        padding: "0 16px",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
      },
    },
  },
  TextFieldProps: {
    sx: {
      marginTop: "0.625rem",
      borderRadius: "16px",
      fontSize: "14px",
      lineHeight: "22px",
      fontWeight: 500,
      height: "170px",
    },
  },

  svgIcon: {
    width: "25px",
    cursor: "pointer",
    height: "25px",
    margin: "0px -4px -4px 0px",
  },
  textField: {},
  textArea: {},
  buttonBox: {
    display: "flex",
    justifyContent: "center",
  },
  addMore: {
    height: "40px",
    padding: "10px 12px",
    gap: "2px",
    borderRadius: "34px",
    borderColor: theme.palette.custom.mainBlue,
    color: theme.palette.custom.mainBlue,
    textTransform: "none",
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "16px",
    letterSpacing: "0px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "145px",
    "& .MuiSvgIcon-root": {
      width: "16px",
      height: "16px",
    },
    "&:hover": {
      borderColor: theme.palette.custom.mainBlue,
      backgroundColor: "rgba(42, 133, 255, 0.05)",
    },
  },
  socialMediaWrapper: {
    marginTop: "10px",
    display: "flex",
    alignItems: "center",
    width: "100%",
    height: "48px",
    padding: "12px",
    gap: "10px",
    border: "1px solid #E4E7E9",
    borderRadius: "28px",
  },
  separator: {
    fontSize: "14px",
    fontWeight: 500,
    color: "#C4C4C4",
  },
  socialMediaInput: {
    flex: 1,
    caretColor: "#5b87f8",
    "& .MuiInputBase-input": {
      fontFamily: "Inter",
      fontWeight: 500,
      fontSize: "15px",
      lineHeight: "20px",
      letterSpacing: "-0.02em",
      color: theme.palette.custom.mainBlue,

      "&::placeholder": {
        color: "#B0B0B0",
        opacity: 1,
        textDecoration: "none",
      },
    },
  },
  errorText: {
    fontSize: "13px",
    color: "#D32F2F",
    marginTop: "2px",
  },
  accountInformationConteiner: {
    display: "flex",
    flexDiraction: "column",
  },
  label: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    letterSpacing: "0%",
    color: "#2A2D31",
  },
  selectBox: {
    marginTop: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: "54px",
    width: "100%",
    backgroundColor: "#F7F9FB",
    borderRadius: "26px",
    padding: "8px 16px",
  },
  selectPlaceholder: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "22px",
    color: "#9DA6B0",
  },
  inputMentorBox: {
    marginTop: "10px",
    width: "100%",
    height: "54px",
    border: "1px solid #E4E7E9",
    borderRadius: "26px",
    padding: "8px 16px",
    display: "flex",
    alignItems: "center",
  },
  inputMentor: {
    flex: 1,
    minWidth: 0,
    caretColor: "#5b87f8",

    "& .MuiInputBase-input": {
      fontFamily: "Inter",
      fontWeight: 500,
      fontSize: "16px",
      lineHeight: "150%",
      color: "#2A2D31",
      letterSpacing: "0%",

      "&::placeholder": {
        color: "#C6CACE",
        opacity: 1,
      },
    },
  },

  resultList: {
    minHeight: 0,
    width: "100%",
    maxHeight: "240px",
    overflowY: "auto",
    backgroundColor: "#FFFFFF",
    borderRadius: "8px",
    padding: "8px",
    marginTop: "12px",
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    transition: "all 0.3s ease",
    boxShadow: "0px 0px 16px rgba(0, 0, 0, 0.1)",
  },

  resultItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    borderRadius: "8px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#F5F5F5",
    },
  },

  avatar: {
    width: "40px",
    height: "40px",
    borderRadius: "26px",
    border: "1px solid #E4E7E9",
  },

  mentorUsername: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "145%",
    color: "#2A2D31",
  },

  notFoundText: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "145%",
    color: "rgba(42, 45, 49, 0.5)",
    marginBottom: "6px",
  },

  fallbackText: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "135%",
    color: "#2A2D31",
    letterSpacing: "0.5px",
    textDecoration: "underline",
    textDecorationStyle: "solid",
    cursor: "pointer",
  },
  ArrowWrapper: {
    width: "20px",
    height: "20px",
  },
  TextBoxWrapper: { display: "flex", alignItems: "center", cursor: "pointer", width: "260px" },
  mentorChip: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "150%",
    letterSpacing: "0%",
    color: theme.palette.custom.mainBlue,
  },
  dialogPaper: {
    borderRadius: "24px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  tradingStyleWrapper: {
    marginTop: "10px",
    width: "764px",
    height: "54px",
    borderRadius: "26px",
    justifyContent: "space-between",
    padding: "8px 16px",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    overflow: "avto",
  },
};
